// extracted by mini-css-extract-plugin
export default {"outdatedBrowserBanner":"outdated-browser-banner__outdatedBrowserBanner--hkIax","title":"outdated-browser-banner__title--ShdSe","text":"outdated-browser-banner__text--pijaD"};